export default "__VITE_ASSET__fyU0LuEa__"